import { render, staticRenderFns } from "./ResultForm.vue?vue&type=template&id=6b0fb3f6&scoped=true&"
import script from "./ResultForm.vue?vue&type=script&lang=js&"
export * from "./ResultForm.vue?vue&type=script&lang=js&"
import style0 from "./ResultForm.vue?vue&type=style&index=0&id=6b0fb3f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0fb3f6",
  null
  
)

export default component.exports